import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "motion/react";
import { usePrefersReducedMotion } from "./motion";

/**
 * CRT "power-on" intro: a quick white horizontal sweep that expands from a
 * center line, then the whole shell settles with a slight scale + brightness
 * pop. ~600ms total, then it unmounts. Skipped entirely under reduced-motion.
 */
export function PowerOn() {
  const reduced = usePrefersReducedMotion();
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (reduced) {
      setDone(true);
      return;
    }
    const t = window.setTimeout(() => setDone(true), 620);
    return () => window.clearTimeout(t);
  }, [reduced]);

  if (reduced) return null;

  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          className="lp-poweron"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.18 }}
          aria-hidden
        >
          {/* The bright scan line that snaps open vertically */}
          <motion.div
            className="lp-poweron-sweep"
            initial={{ scaleY: 1, scaleX: 0.2, opacity: 1 }}
            animate={{
              scaleX: [0.2, 1, 1],
              scaleY: [1, 1, 280],
              opacity: [1, 1, 0],
            }}
            transition={{ duration: 0.55, times: [0, 0.45, 1], ease: "easeInOut" }}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
